import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../Components/Button/Button'
import { useLocalization } from '../../../Hooks/useLocalization'
import './AnnouncementList.scss'
import { setDestinationView } from '../../../Store/InterfaceSlice'
import { type RootState } from '../../../Store/Store'
import { useEffect, useMemo } from 'react'
import {
  setAnnouncements,
  setIsAnnouncementsRequested,
} from '../../../Store/DataSlice'
import { getAuthorizationHeader } from '../../../Orchestration/Authentication'
import { HtmlTextDisplay } from '../../../Components/HtmlTextDisplay/HtmlTextDisplay'
import { toBelgianDate } from '../../../Utils/Formatting'

const localizationSection = 'announcement'
export function AnnouncementList() {
  const dispatch = useDispatch()
  const localization = useLocalization(localizationSection)

  const isAnnouncementsRequested = useSelector(
    (state: RootState) => state.data.isAnnouncementsRequested
  )
  useEffect(() => {
    if (!isAnnouncementsRequested) dispatch(setIsAnnouncementsRequested(true))
  }, [isAnnouncementsRequested, dispatch])

  const allAnnouncements = useSelector(
    (state: RootState) => state.data.announcements
  )
  const sortedAnnouncements = useMemo(
    () => [...allAnnouncements].sort((a, b) => b.date - a.date),
    [allAnnouncements]
  )

  const user = useSelector((state: RootState) => state.authentication.user)
  const isAdmin = user?.isAdmin ?? false

  const deleteAnnouncement = (announcementUuid: string) => {
    if (
      announcementUuid != null &&
      window.confirm(
        localization.text(
          'delete-announcement-prompt',
          'Ben je zeker dat je deze aankondiging permanent wilt verwijderen?'
        )
      )
    ) {
      fetch(
        `https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/announcement-delete`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...getAuthorizationHeader(),
          },
          body: JSON.stringify({
            announcementUuid,
          }),
        }
      )
        .then(() => {
          dispatch(
            setAnnouncements(
              sortedAnnouncements.filter((a) => a.uuid !== announcementUuid)
            )
          )
          dispatch(setIsAnnouncementsRequested(false))
        })
        .catch((err) => {
          console.warn(`fetch announcement-delete failed: `, err)
        })
    }
  }

  return (
    <div className="announcement-list">
      {isAdmin && (
        <div className="button-row">
          <Button
            importance={'primary'}
            text={localization.text(
              'add-announcement',
              'Voeg aankondiging toe'
            )}
            onClick={() =>
              dispatch(
                setDestinationView({
                  destinationView: 'announcement-add',
                })
              )
            }
          />
        </div>
      )}
      <div className="announcements-list">
        {sortedAnnouncements.map((announcement) => (
          <div key={announcement.uuid} className="announcement-item">
            <div className="announcement-header">
              <div className="announcement-date">
                {toBelgianDate(announcement.date)}
              </div>
              <div className="announcement-title">{announcement.title}</div>
              {isAdmin && (
                <>
                  <Button
                    importance="primary"
                    size="small"
                    onClick={() =>
                      dispatch(
                        setDestinationView({
                          destinationView: 'announcement-edit',
                          detailKey: announcement.uuid,
                        })
                      )
                    }
                    text={localization.text('edit', 'Editeer aankondiging')}
                  />
                  <Button
                    importance={'danger'}
                    size="small"
                    text={localization.text(
                      'remove-button',
                      'Verwijder aankondiging'
                    )}
                    onClick={() => {
                      deleteAnnouncement(announcement.uuid)
                    }}
                  />
                </>
              )}
            </div>
            <HtmlTextDisplay
              className="announcement-message"
              value={announcement.message}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
